import React from 'react';
import Modal from '../Modal';
import LazyRenderQRCode from './LazyRenderQRCode';
import {FormattedMessage} from 'react-intl';
import {apiServer} from '../../../api';

function QrCodeModal({visible, onClose, value}) {
  return (
      <Modal visible={visible} title={"QR Code"} onClose={onClose}>
          <div className="text-center rounded border bg-primary-subtle border-primary p-2">
              <a href={value} target={"_blank"}>{formattedUrl(value)}</a>
          </div>
        <div className={"p-4 text-center"}>
          <LazyRenderQRCode value={value} size={240} level={'H'}/>
        </div>
        <div className="text-center">
          <a href={`${apiServer}/extras/qr?data=${encodeURIComponent(value)}`}>
            <FormattedMessage id={"Download"}/>
          </a>
        </div>
      </Modal>
  );
}

function formattedUrl(href){
    if(!href) return '';
    try {
        const u = new URL(href);
        return u.hostname + u.pathname + u.search;
    }catch(e){
        console.log(e);
        return href;
    }
    // return new URL(href)
}

export default QrCodeModal;
